import type { ServerResponseV1 } from "@/http"
import type { Media } from "@/models"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"
import { MediaType } from "@/models"

interface IUsePinMediaArgs {
  eventVaultId: number
  isPinned: boolean
  media: Media[]
}

interface IPinMediaRequest {
  isPinned: boolean
  selectedMedia: {
    Photo: number[]
    Video: number[]
  }
}

export async function pinMedia(eventVaultId: number, isPinned: boolean, media: Media[]) {
  const request: IPinMediaRequest = {
    isPinned,
    selectedMedia: {
      Photo: [],
      Video: [],
    },
  }

  for (const item of media) {
    if (item.id === undefined)
      continue
    if (item.type === MediaType.Pic)
      request.selectedMedia.Photo.push(item.id)
    else if (item.type === MediaType.Vid)
      request.selectedMedia.Video.push(item.id)
  }

  return await v1.patch<ServerResponseV1<void>>(`/events/${eventVaultId}/favourites`, request)
}

export function usePinMedia() {
  return useMutation({
    mutationFn: ({ eventVaultId, isPinned, media }: IUsePinMediaArgs) => pinMedia(eventVaultId, isPinned, media),
  })
}
